(function () {
  function mountIframe(card){
    const id = card.getAttribute('data-yt');
    if(!id || card.classList.contains('yt-facade--playing')) return;
    const params = card.getAttribute('data-params') || 'autoplay=1&rel=0';
    const ifr = document.createElement('iframe');
    ifr.src = `https://www.youtube.com/embed/${id}?${params}`;
    ifr.setAttribute('title','YouTube video');
    ifr.setAttribute('frameborder','0');
    ifr.setAttribute('allowfullscreen','');
    ifr.setAttribute('allow','accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
    ifr.style.width='100%'; ifr.style.height='100%';
    card.replaceChildren(ifr);
    card.classList.add('yt-facade--playing');
  }
  document.addEventListener('click', e => {
    const card = e.target.closest('.yt-facade');
    if (!card) return;
    mountIframe(card);
  });
})();


